export enum FinanceReportFields {
  Date = 'date',
}
